import { connect } from "react-redux";
import { KiemTraNoXau } from "components/KiemTraNoXau";
import { getListKiemTraNoXau } from "actions/KiemTraNoXau";

const mapStateToProps = (state) => ({
  kiemtranoxau: state.kiemtranoxau,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListKiemTraNoXau: (dataSearch) =>
    dispatch(getListKiemTraNoXau(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KiemTraNoXau);
